window.addEventListener("DOMContentLoaded", event => {
  let links = document.querySelectorAll('footer h5');
  const maxwidth = window.matchMedia("(max-width: 781px)");
  if (maxwidth.matches) {
    for (var i = 0, len = links.length; i < len; i++) {
      links[i].setAttribute('tabindex', '0');
    }
  }
  links.forEach(function (link) {
    link.addEventListener('click', function () {
      link.classList.toggle('active');
      link.closest('div').querySelector('ul').classList.toggle('collapsed');
    });
    link.addEventListener('keypress', function (e) {
      if (e.key === "Enter") {
        link.classList.toggle('active');
        link.closest('div').querySelector('ul').classList.toggle('collapsed');
      }
    });
  });
});